import React, { useState } from "react";

//Styles
import defaultClasses from "./cookieBanner.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";

//Components
import { useIntl } from "react-intl";
import Button from "../../overrides/venia-ui/components/Button";
import { areCookieSetted, setAllCookieSelected, setRequiredCookieSelected } from "../SpecificCookiesChecks/cookiesTypes";
import { useHistory } from "react-router";
import { useAppContext } from "@magento/peregrine/lib/context/app";
import Modal from "@Components/Modal";
import { env } from "build/env";
var CookieBanner = _ref => {
  var {
    classes: propsClasses
  } = _ref;
  var [, {
    closeDrawer
  }] = useAppContext();
  var {
    formatMessage
  } = useIntl();
  var classes = mergeClasses(defaultClasses, propsClasses);
  var [cookieBarHidden, setCookieBarHidden] = useState(false);
  var {
    push
  } = useHistory();

  //TODO find a way to put cookie banner in front of footer-nav
  var shouldBeHidden = areCookieSetted() || cookieBarHidden;
  if (env.DISABLE_COOKIE_BANNER === true || shouldBeHidden) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Modal, {
    id: "modal-cookie-banner",
    nameClass: "modal-cookie-banner",
    isOpen: !shouldBeHidden,
    modalDialogClass: "uk-position-fixed section-rounded uk-position-bottom uk-width-1-1",
    animation: "uk-animation-slide-bottom",
    canBeClosed: false
  }, /*#__PURE__*/React.createElement("div", {
    className: " ".concat(classes.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-column ".concat(classes.cookieBanner)
  }, /*#__PURE__*/React.createElement("button", {
    id: "cookieBannerOnlyRequired",
    className: "".concat(classes.onlyRequired),
    onClick: () => {
      setRequiredCookieSelected();
      setCookieBarHidden(true);
    }
  }, formatMessage({
    id: "button.cookie.onlyrequired"
  })), /*#__PURE__*/React.createElement("span", {
    className: "uk-padding-small uk-padding-remove-vertical uk-text-justify uk-width-5-6@m uk-align-center uk-margin-remove-vertical ".concat(classes.text)
  }, formatMessage({
    id: "cookie.policy.info.part1"
  }), " ", /*#__PURE__*/React.createElement("a", {
    href: "/cookie-policy",
    target: "_blank"
  }, formatMessage({
    id: "cookie.policy"
  })), formatMessage({
    id: "cookie.policy.info.part2"
  }), " ", /*#__PURE__*/React.createElement("b", null, formatMessage({
    id: "cookie.policy.more.info"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-center uk-flex-wrap uk-position-small ".concat(classes.buttons)
  }, /*#__PURE__*/React.createElement(Button, {
    id: "cookieBannerMoreInfo",
    color: "white",
    onClick: () => {
      push("/cookie-policy");
      setCookieBarHidden(true);
    }
  }, formatMessage({
    id: "button.more.info"
  })), /*#__PURE__*/React.createElement(Button, {
    id: "cookieBannerAccept",
    color: "white",
    onClick: () => {
      setAllCookieSelected(true);
      closeDrawer();
      setCookieBarHidden(true);
    }
  }, formatMessage({
    id: "button.accept.cookie"
  }))))));
};
export default CookieBanner;